import type { TFunction } from 'i18next';
import type { CustomFieldEntry } from '@config';

import { ActionEntityType } from '@pmp/api';

/**
 * `/configuration/additionalFields` returns one flat list with neither entity nor type on it, and
 * only products carry custom fields today, so both are filled in here. Every field is free text.
 * TODO PMP-2094 read the entity and the type from the API once it reports them.
 */
export const buildCustomFields = (
  t: TFunction,
  fields?: { code: string; name?: string | null }[],
): CustomFieldEntry[] =>
  (fields ?? []).map(field => ({
    code: field.code,
    name: field.name ?? field.code,
    entity: ActionEntityType.PRODUCTS,
    entityLabel: t(`pmp.entities.${ActionEntityType.PRODUCTS}`, { defaultValue: ActionEntityType.PRODUCTS }),
    type: 'text' as const,
  }));
